import React from "react";
import ProgressCircle from "../progress-circle/ProgressCircle";
import printingIcon from "../../../assets/png/printing-icon.png";
import audioBookIcon from "../../../assets/png/audiobook-icon.png";
import lockedIcon from "../../../assets/png/locked-icon.png";
import unlockedIcon from "../../../assets/png/unlocked-icon.png";
import { useTranslation } from "react-i18next";
import { CATEGORY_ID_TO_LABEL } from "../../../core/constants/constants";
import "./BookCard.css";

const BookCard = ({
  item,
  index,
  isTopCard = false,
  imageSrc,
  progress,
  actions,
}) => {
  const { t } = useTranslation();
  const paid = item.is_paid;
  const categoryLabel =
    CATEGORY_ID_TO_LABEL[item.general_category_id];

  const {
    navigate,
    setEditBook,
    setShowEditModal,
    setShowDeleteModal,
    setMenuOpenIndex,
    bookToDeleteResource,
    menuOpenIndex,
  } = actions;

  const onMenuClick = (e) => {
    e.stopPropagation();
    setMenuOpenIndex(menuOpenIndex === index ? null : index);
  };

  const onDeleteClick = () => {
    bookToDeleteResource.current = { item, index };
    setShowDeleteModal(true);
    setMenuOpenIndex(null);
  };

  const onRenameClick = () => {
    setEditBook({ item, index });
    setShowEditModal(true);
    setMenuOpenIndex(null);
  };

  const BookCardMain = () => (
    <div
      className="book-card-main"
      onClick={() => navigate("/questions/" + item.id)}
    >
      {imageSrc ? (
        <img src={imageSrc} alt="cover" className="book-cover" />
      ) : (
        <div className="book-cover placeholder" />
      )}
      <div className="book-info">
        <div className="book-title-name">
          <img
            className="lock-status-icon"
            src={paid ? unlockedIcon : lockedIcon}
            alt={paid ? t("unlocked") : t("locked")}
            title={paid ? t("unlocked") : t("locked")}
          />
          {item.book_name}
        </div>
        <div className="book-subtitle">
          {t(`book_type.${categoryLabel}`) || t("other")}
        </div>
      </div>
    </div>
  );

  const BookActions = () => (
    <div className="book-card-actions">
      <ProgressCircle percentage={progress} />
      <div
        onClick={() => navigate("/printing")}
        className="icon"
        title={t("print_book")}
      >
        <img src={printingIcon} alt="Print Book" className="icon-image" />
      </div>
      <div
        className="icon"
        title={t("audio_book")}
        onClick={() => navigate("/questions/" + item.id)}
      >
        <img src={audioBookIcon} alt="Audio Book" className="icon-image" />
      </div>
      <div className="menu-wrapper">
        <button className="menu-button" onClick={onMenuClick}>
          ⋮
        </button>
        {menuOpenIndex === index && (
          <div className="menu-dropdown">
            <div onClick={() => navigate("/questions/" + item.id)}>
              {t("edit")}
            </div>
            <div onClick={onRenameClick}>{t("rename")}</div>
            <div onClick={onDeleteClick} className="text-danger">
              {t("delete")}
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (isTopCard) {
    return (
      <div key={item.id} className="book-card top-card">
        <div className="continue-section">
          <div className="continue-title">
            {t("continue_where_you_left_off")}
          </div>
          <div
            className="continue-button"
            onClick={() => navigate("/questions/" + item.id)}
          >
            {t("continue")} →
          </div>
        </div>
        <div className="top-card-content">
          <BookCardMain />
          <BookActions />
        </div>
      </div>
    );
  }

  return (
    <div key={item.id} className="book-card">
      <BookCardMain />
      <BookActions />
    </div>
  );
};

export default React.memo(BookCard);
